import {isDev} from "@/components/DownloaderApp/utils";

export const logger = {
    log: (...args) => {
        if (isDev) {
            console.log(...args);
        }
    },
}